import { SuperSchema } from '@updater/ui-informant';
import {
  INTERNET_USERS_QUESTION,
  InternetUsers,
  toOneOf,
  withoutAnswers,
} from '@updater/ui-widgets';

// Internet is assumed on these microsites, so there is no opting out of it.
const question = withoutAnswers(INTERNET_USERS_QUESTION, [
  InternetUsers.NOT_NEEDED,
]);

/**
 * Carries no schema `default` on purpose: it is the first question asked, and a
 * defaulted first question is one the 'latest' restart policy enters past. See
 * `buildQuizLayout`.
 */
export const internetUsersMerchandisingSchema: SuperSchema = {
  type: 'object',
  properties: {
    internetUsers: {
      type: 'string',
      oneOf: toOneOf(question),
      ui: { component: 'radioPillList' },
    },
  },
  required: ['internetUsers'],
};
